import React from 'react';
import { motion } from 'framer-motion';

export const InfoOverlay = ({ selectedId, data, onClose, onNavigate }) => {
    if (!selectedId) return null;
    const itemData = data[selectedId];

    const handleContentClick = (e) => {
        // Check if the clicked element or its parent has the navigation class
        const target = e.target.closest('.js-navigate-simulation');
        if (target && onNavigate) {
            e.preventDefault();
            onNavigate('simulation');
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 50 }}
            transition={{ type: "spring", damping: 25, stiffness: 200 }}
            className="absolute top-0 right-0 h-full w-full md:w-[500px] p-4 md:p-8 z-20 flex items-center justify-end pointer-events-none"
        >
            {/* The Box Container */}
            <div className="w-full h-full max-h-[90vh] bg-white/95 backdrop-blur-2xl rounded-3xl shadow-2xl border border-white/50 flex flex-col overflow-hidden pointer-events-auto">

                {/* Header */}
                <div className="p-8 pb-6 border-b border-gray-100 bg-gray-50/50">
                    <div className="flex justify-between items-start mb-2">
                        <p className="text-xs font-bold text-gray-400 tracking-widest uppercase">{itemData.subtitle}</p>
                        <button
                            onClick={onClose}
                            className="p-2 -mr-2 -mt-2 hover:bg-gray-200/50 rounded-full transition-colors group"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400 group-hover:text-gray-600">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                    <h2 className="text-3xl font-black tracking-tight leading-tight" style={{ color: itemData.color }}>
                        {itemData.title}
                    </h2>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto scroll-smooth custom-scrollbar p-8">
                    <div
                        className="prose prose-sm prose-blue max-w-none text-gray-600 leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: itemData.content }}
                        onClick={handleContentClick}
                    />
                </div>

                {/* Footer */}
                <div className="p-6 bg-gray-50 border-t border-gray-100">
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-xs">
                            PK
                        </div>
                        <div>
                            <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">Reference</p>
                            <p className="text-xs text-gray-500 truncate max-w-[250px]">Premnath K. Narayanan, PhD Thesis 2025</p>
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};
